function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "11 2 2 2 2 11 4 11 4 4 11 4 11 2"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "2 21 2 30 11 30 11 28 4 28 4 21 2 21"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "30 11 30 2 21 2 21 4 28 4 28 11 30 11"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "21 30 30 30 30 21 28 21 28 28 21 28 21 30"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.49,10.13l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,6,11V21a1,1,0,0,0,.51.87l9,5a1,1,0,0,0,1,0l9-5A1,1,0,0,0,26,21V11A1,1,0,0,0,25.49,10.13ZM16,7.14,22.94,11,16,14.86,9.06,11ZM8,12.7l7,3.89V24.3L8,20.41Zm9,11.6V16.59l7-3.89v7.71Z"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "cls-1",
  width: 32,
  height: 32
});

var Svg3DMprToggle = function Svg3DMprToggle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3DMprToggle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3D-MPR-Toggle.15840c7c.svg";
export { ForwardRef as ReactComponent };